import React, { useState, useEffect, Fragment } from 'react';
import { Document, Page, pdfjs } from "react-pdf";

import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Input,
    Label,
    Row,
    Form,
    Col
} from "reactstrap";
import { ButtonGroup } from 'reactstrap';
import Loader from 'react-spinners/PulseLoader';
import styled from 'styled-components';

const ModalPowerpoint = ({
    open,
    handleModal,
    s_link
}) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const handleLoading = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            handleLoading();
        }
    };

    const goToNextPage = () => {
        setCurrentPage(currentPage + 1);
        handleLoading();
    };

    const toggle = (e) => handleModal(!open);

    return (
        s_link &&
        <Modal isOpen={open} toggle={toggle} size="lg" style={{ maxWidth: '80%' }}>
            <ModalHeader toggle={toggle}>PowerPoint:</ModalHeader>
            <ModalBody style={{ height: '70vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <iframe
                    src={`${s_link}#page=${currentPage}&zoom=page-fit&navpanes=0`}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    key={currentPage}
                />
            </ModalBody>
            <ModalFooter>
                <ButtonGroup>
                    <Button onClick={goToPreviousPage}>Previous</Button>
                    <Button onClick={goToNextPage}>Next</Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    );

    return (
        <CustomModal isOpen={open} toggle={(e) => handleModal(!open)}>
            <CustomModalBody>
                <iframe
                    src={`${s_link}#page=${currentPage}&zoom=page-fit&navpanes=0`}
                    width="100%"
                    height="800px"
                    title="PDF Viewer"
                    key={currentPage}
                />
                <Loading display={loading} />
            </CustomModalBody>
            <ModalFooter>
                <ButtonGroup>
                    <Button onClick={goToPreviousPage}>Previous</Button>
                    <Button onClick={goToNextPage}>Next</Button>
                </ButtonGroup>
            </ModalFooter>
        </CustomModal>
    );
}

export default ModalPowerpoint;

const Loading = ({
    display
}) => {

    if (!display) return null;

    return (
        <LoadingDiv>
            <Loader type="ThreeDots" color="lightblue" className='loader-search' />
        </LoadingDiv>
    );
}

const LoadingDiv = styled.div`
    height: 700px;
    width: 1500px;
    position: absolute;
    z-index: 1000;
    background-color: white;
    top: 58px;
    right: 8%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CustomModal = styled(Modal)`
    width: 100%;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
`;

const CustomModalBody = styled(ModalBody)`
    width: 100%;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
`;

const IframeContainer = styled.div`
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    width: 80%; /* 80% of the viewport or parent width */
    margin: auto; /* Center the container in the middle */
    max-width: 100%; /* Ensure it doesn’t exceed the viewport width */
    border: 1px solid red; /* Optional: for visual debugging */
    height: 80vh;
`;

const Iframe = styled.iframe`
    aspect-ratio: 4 / 3;
    width: 100%;
`;